/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import Button from '../Button';
import iconCheckMark from '../../assets/icons/ic_checkbox_checkmark.svg';

export type layoutType = 'PRIMARY' | 'SECONDARY';

interface Props {
  buttonLabel: string;
  title: string;
  onClickAction: (newItems: CheckboxItemProps[]) => void;
  contentHeight?: 'small' | 'medium'
  type?: 'single' | 'multiple'
  items: CheckboxItemProps[],
  isClearedOnceClicked?: boolean;
  isButtonNeeded: boolean;
  actionWhenChecked?: boolean;
  mode: layoutType;
}

export type CheckboxItemProps = {
  checked?: boolean;
  label: string;
  key?: string;
}

const CheckboxListItemView:React.FC<Props> = ({
  buttonLabel,
  isClearedOnceClicked = false,
  onClickAction,
  actionWhenChecked = false,
  title,
  type = 'single',
  contentHeight = 'small',
  items,
  isButtonNeeded,
  mode,
}) => {
  const [checkItems, setCheckItems] = useState(items);
  const [value, setValue] = useState(0); // for rendering

  const clearChecked = () => {
    items.forEach((each) => {
      const newEach = each;
      newEach.checked = false;
    });
    setCheckItems(items);
  };

  function layoutCheckboxListPrimary() {
    return checkItems.map((item, idx) => {
      const background = (item.checked) ? 'bg-light-active-secondary' : '';
      const checkboxBackground = (item.checked) ? 'bg-gojek-green' : '';
      const fontType = (item.checked) ? 'font-medium' : 'font-light';
      return (
        <div key={`item ${idx + 1}`} className={`flex flex-row p-4 ${background} rounded-2xl self-center mt-2`}>
          <div className={`grow text-sm ${fontType}`}>{item.label}</div>
          <button
            aria-hidden="true"
            type="button"
            onClick={() => {
              const foundIndex = checkItems.indexOf(item);
              const found = checkItems[foundIndex];

              if (type === 'single') {
                // reset all to checked false
                checkItems.forEach((each) => {
                  const newEach = each;
                  newEach.checked = false;
                });
              }

              if (found) {
                checkItems[foundIndex].checked = !item.checked;
              }
              setCheckItems(checkItems);
              setValue(value + 1);
            }}
          >
            <div className={`flex-none w-5 h-5 rounded-lg border ${checkboxBackground}`}>
              {item.checked && <img className="mt-1 ml-1" src={iconCheckMark} alt={iconCheckMark} />}
            </div>
          </button>
        </div>
      );
    });
  }

  function layoutCheckboxListSecondary() {
    return checkItems.map((item, idx) => {
      const background = (item.checked) ? 'bg-light-active-secondary' : '';
      const checkboxBackground = (item.checked) ? 'bg-gojek-green' : '';
      const fontType = (item.checked) ? 'font-medium' : 'font-light';
      const notSelected = !item.checked;
      return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div
          key={`item ${idx + 1}`}
          className={`flex cursor-pointer flex-row p-4 ${background} rounded-2xl self-center mt-2`}
          onClick={() => {
            const foundIndex = checkItems.indexOf(item);
            const found = checkItems.at(foundIndex);

            if (type === 'single') {
              // reset all to checked false
              checkItems.forEach((each) => {
                const newEach = each;
                newEach.checked = false;
              });
            }

            if (found) {
              checkItems[foundIndex].checked = !item.checked;
            }
            setCheckItems(checkItems);
            setValue(value + 1);
            if (actionWhenChecked) {
              onClickAction(checkItems);
            }
          }}
        >
          <div className={`grow text-sm ${fontType}`}>{item.label}</div>
          <button
            aria-hidden="true"
            type="button"
          >
            <div className={`flex-none w-5 h-5 rounded-lg border ${checkboxBackground} ${notSelected ? 'hidden' : ''}`}>
              {item.checked && <img className="mt-1 ml-1" src={iconCheckMark} alt={iconCheckMark} />}
            </div>
          </button>
        </div>
      );
    });
  }

  const layoutCheckboxList = (layoutModeType: layoutType) => {
    switch (layoutModeType) {
      case 'PRIMARY':
        return layoutCheckboxListPrimary();
      case 'SECONDARY':
        return layoutCheckboxListSecondary();
      default:
        return layoutCheckboxListPrimary();
    }
  };

  function getButtonState() {
    const disabled = checkItems.filter((each) => each.checked).length <= 0;

    if (disabled) return 'disabled';
    return 'primary';
  }

  return (
    <div>
      <div className="text-sm font-medium text-disabled">{title}</div>
      <div className={`overflow-y-auto pb-2 mb-2 ${contentHeight === 'small' ? 'h-[249px]' : 'h-[340px]'}`}>
        {layoutCheckboxList(mode)}
      </div>
      {isButtonNeeded && (
        <Button
          size="small"
          label={buttonLabel}
          type={getButtonState()}
          onClick={() => {
            onClickAction(checkItems);
            // eslint-disable-next-line no-unused-expressions
            isClearedOnceClicked && clearChecked();
          }}
        />
      )}

    </div>
  );
};

export default CheckboxListItemView;
